import { toast } from "react-hot-toast";

export const successToast = (message: string) => {
  return toast.success((t) => (
    <span
      className="break-words"
      style={{ whiteSpace: "pre-line" }}
      onClick={() => toast.dismiss(t.id)}
    >
      {message}
    </span>
  ));
};

export const errorToast = (message: string) => {
  return toast.error((t) => (
    <span
      className="break-words"
      style={{ whiteSpace: "pre-line" }}
      onClick={() => toast.dismiss(t.id)}
    >
      {message}
    </span>
  ));
};
